export const DELETE_TITLE = 'Confirmação de exclusão';

export const DELETE_BUTTON = 'Confirmar';

export const DELETE_MESSAGE = `
  Deseja realmente excluir este estagiário?
  <br><br>
  <strong>
    Ao excluir o cadastro, os cálculos deste (a) estagiário (a) também serão excluídos do módulo folha.
  </strong>`;

export const TABLE_COLUMNS_HEADER = [
  { name: 'Matrícula do eSocial', key: 'registration' },
  { name: 'Nome', key: 'internName' },
  { name: 'CPF', key: 'cpf' },
  { name: 'Categoria', key: 'category', sortable: false },
  { name: 'Data de Início', key: 'beginDate' },
  { name: 'Data de Término', key: 'endDate' },
];
export const DEFAULT_PAGINATION = {
  totalItems: 1,
  page: 1,
};
